import { stopPropagation } from '../../../utils/events'
import { ProfileUserInfoItem } from '../ProfileUserInfoItem'
import { isNeedToShowUserItemIcons } from '../ProfileUsersWidgetItem'

import { isManagerDeleting } from './ProfileResponsibleManagersWidgetItem.utils'
import { ProfileResponsibleManagersWidgetItemIcons } from './ProfileResponsibleManagersWidgetItemIcons'

function ProfileResponsibleManagersWidgetItem({
  canDelete,
  deleteButtonQaName,
  deletingManagerId,
  value,
  onDelete,
  ...restProps
}) {
  const isDeleting = isManagerDeleting({ deletingManagerId, manager: value })

  function handleDelete(event) {
    stopPropagation(event)

    onDelete(value.id)
  }

  function handleNeedToShowIcons(iconsState) {
    return isDeleting || isNeedToShowUserItemIcons(iconsState)
  }

  return (
    <ProfileUserInfoItem
      {...restProps}
      Icons={ProfileResponsibleManagersWidgetItemIcons}
      disabled={isDeleting}
      iconsProps={{
        canDelete,
        deleteButtonQaName,
        isDeleting,
        isDisabled: Boolean(deletingManagerId),
        onDelete: handleDelete,
      }}
      isArchived={Boolean(value?.archived)}
      isNeedToShowIcons={handleNeedToShowIcons}
      value={value}
    />
  )
}

export default ProfileResponsibleManagersWidgetItem
